import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=0b058ffe&scoped=true"
import script from "./Audit.vue?vue&type=script&lang=js"
export * from "./Audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b058ffe",
  null
  
)

export default component.exports